export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-15.jpg'),
        title: '全球化/本地化',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '全球化/本地化',
      description: `<p style="font-size:1.05rem">
      Maesinfo.是一家专业为全球知名企业、大型机构提供智能化IT解决方案的创新性服务公司，总部位于"中国软件名城"成都。主营包括软件（应用软件， 手机软件，嵌入式软件等）开发服务, IT 解决方案， QA/QC服务；系统集成；软件维护和IT基础设施维护服务，同时为客户提供全方位的商务流程外包解决方案包括数据录入、数据处理、数据清洗， 呼叫服务；人才培训等。在国家的改革开放政策和各级党委、政府、社会各界的关心、支持和帮助下，迈思信息（MaesInfo）近年来均保持较快增长速度。
在深圳、常州、西安建立了分公司。
</p>`
    },
    {
      title: '全球化：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-15.jpg')+`)"></span>
      <span>迈思信息（MaesInfo）在美国Mountain View（山景城）、Pittsburgh（匹兹堡）拥有市场和项目管理中心。在人才储备方面，迈思信息（MaesInfo）面向全球招揽各种技术和专业领域的优秀人才，目前员工来自全球多个国家和地区 (如中国、印度、美国、加拿大、菲律宾、香港)</span>`
    }
  ]
}
